import axios from "axios";

const actions = {
  getReport(context, { period, year, month }) {
    return axios
      .get("reports", {
        params: {
          period,
          year,
          ...(period === "month" ? { month } : {}),
        },
      })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
